import { Outlet } from 'react-router-dom'

const RootPage = () => {
  return <Outlet />
}

export default RootPage
